<template>
    <div>
        <k-select
            v-on="$listeners"
            :inline-dropdown="true"
            class="mb-4"
            v-if="!createClassLevel"
            v-model="model"
            :options="options"
            :multiple="false"
            :simplified="false"
            :required="true"
            :allowSearch="true"
            :serverSideSearch="true"
            :showSelectedOptions="false"
            :error="localError"
            :scroll-max-height="110"
            autoClose="true"
            :label="trans('general.classes.level.select_level')"
            :placeholder="trans('general.classes.level.select_level_for_class')"
            v-on:search="loadOptions">
            <template v-slot:header v-if="allowNew">
                <div class="dropdown-item bg-light-blue title small text-black d-flex align-items-center gap-1"
                     role="button"
                     @click="showCreateClassLevel">
                    <i class="fi fi-rr-plus-small"></i>
                    {{ trans('general.classes.create_new_level') }}
                </div>
            </template>
        </k-select>

        <div v-if="createClassLevel" class="mb-3 createClassLevel">

            <div class="d-flex align-items-center mb-3 gap-2">
                <basic-button
                    class="text-primary align-items-center pt-1 pe-2 ps-0"
                    @click="createClassLevel = false"
                    icon="fi-rr-arrow-left"/>
                <div class="title small">{{ trans('general.classes.create_new_level') }}</div>
            </div>

            <FormErrorAlerts :errors="errors"></FormErrorAlerts>

            <div class="d-lg-flex gap-2">
                <basic-input
                    type="text"
                    :name="trans('general.classes.levels.age_group_name')"
                    :label="trans('general.classes.levels.age_group_name')"
                    :required="true"
                    v-on:reset-error="errorFields.label = null"
                    :error="errorFields.label"
                    v-model="ageGroupModel.label"/>

                <basic-input
                    type="text"
                    :name="trans('general.classes.levels.age_group_from_to')"
                    :label="trans('general.classes.levels.age_group_from_to')"
                    :required="true"
                    :help="trans('general.tooltip.define_age_group_value')"
                    v-on:reset-error="errorFields.value = null"
                    :error="errorFields.value"
                    v-model="ageGroupModel.value"/>

                <basic-input
                    cls="ratioInput fixed-w-desktop"
                    type="number"
                    :name="trans('general.classes.levels.ratio')"
                    :label="trans('general.classes.levels.ratio')"
                    :required="true"
                    :help="trans('general.tooltip.define_age_group_ratio')"
                    v-on:reset-error="errorFields.description = null"
                    :error="errorFields.description"
                    v-model="ageGroupModel.description"/>
            </div>
            <hr>
        </div>
    </div>
</template>

<script>
import KSelect from "../../../theme/molecules/KSelect.vue";
import BasicButton from "../../../theme/atoms/BasicButton.vue";
import FormErrorAlerts from "../../../theme/molecules/FormErrorAlerts.vue";
import BasicInput from "../../../theme/atoms/BasicInput.vue";
import {handleErrors} from "../../../services/ErrorHandler";

export default {
    name: "ClassLevelSelect",
    props: {
        value: Array|Object,
        error: {
            type: String,
            required: false,
        },
        allowNew: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        BasicInput,
        FormErrorAlerts,
        KSelect,
        BasicButton
    },
    watch: {
        model: function (val) {
            this.$emit('input', val[0]);
        },
        value: function (val) {
            if (val && val.id) this.model = [val];
        },
        error: function (val) {
            this.localError = val
        }
    },
    data() {
        return {
            model: [],
            options: [],
            createClassLevel: false,
            ageGroupModel: {
                label: null,
                value: null,
                description: 4,
            },
            localError: this.error,
            errors: [],
            errorFields: {
                label: null,
                value: null,
                description: null,
            },
            submittingAgeGroup: false,
            tooltipInitiated: false,
        }
    },
    methods: {
        loadOptions(search) {
            axios.get(`/settings/class-level`, {params: {limit: 15, search, search_fields: 'label:like'}})
                .then((response) => {
                    let data = response.data;
                    this.options = data.data.data;
                });
        },

        showCreateClassLevel() {
            this.errorFields = {
                label: null,
                value: null,
            };
            this.createClassLevel = true;

            if(!this.tooltipInitiated) {
                setTimeout(() => {
                    const tooltipTriggerList = [].slice.call(document.querySelectorAll('.createClassLevel [data-bs-toggle="tooltip"]'));
                    tooltipTriggerList.map(function (tooltipTriggerEl) {return new bootstrap.Tooltip(tooltipTriggerEl)});
                    this.tooltipInitiated = true;
                }, 700);
            }
        },

        createNew() {
            const {label, value, description} = this.ageGroupModel;
            this.submittingAgeGroup = true;

            axios.post('/settings/class-level/new', {label, value, description})
                .then(response => {
                    this.submittingAgeGroup = false;
                    this.model = [response.data.data];
                    this.emitSubmit(true);
                })
                .catch((error) => {
                    this.submittingAgeGroup = false;
                    handleErrors(error, this, this.errorFields);
                    this.emitSubmit(false);
                });
        },
        submit() {
            if(this.createClassLevel) {
                this.createNew();
            } else {
                this.emitSubmit(true);
            }
        },
        emitSubmit(status) {
            this.$emit('submit', status);
        }
    },
    mounted() {
        if (this.value) {
            this.model = [this.value];
        }

        this.loadOptions();
    }
}
</script>

<style scoped>
@media screen and (min-width: 768px) {
    .fixed-w-desktop {
        width: 150px;
    }
}
</style>
